export const INTELLISEL_START = 'INTELLISEL_START';
export const INTELLISEL_SUCCESS = 'INTELLISEL_SUCCESS';
export const INTELLISEL_ERROR = 'INTELLISEL_ERROR';
export const INTELLISEL_LOADING = 'INTELLISEL_LOADING';

export type Actions = {
  INTELLISEL_START: {
    type: typeof INTELLISEL_START;
    payload: boolean;
  };
  INTELLISEL_LOADING: {
    type: typeof INTELLISEL_LOADING;
    payload: boolean;
  };
  INTELLISEL_SUCCESS: {
    type: typeof INTELLISEL_SUCCESS;
    payload: any;
  };
  INTELLISEL_ERROR: { type: typeof INTELLISEL_ERROR; payload: any };
};
// Action Creators
export const actionCreators = {
  intelliselStart: (
    payload: any,
  ): Actions[typeof INTELLISEL_START] => ({
    type: INTELLISEL_START,
    payload,
  }),
  intelliselError: (
    payload: any,
  ): Actions[typeof INTELLISEL_ERROR] => ({
    type: INTELLISEL_ERROR,
    payload,
  }),
  intelliselSuccess: (
    payload: any,
  ): Actions[typeof INTELLISEL_SUCCESS] => ({
      type: INTELLISEL_SUCCESS,
      payload,
    }),
  intelliselLoading: (
    payload: boolean,
  ): Actions[typeof INTELLISEL_LOADING] => ({
    type: INTELLISEL_LOADING,
    payload,
  }),
};
